// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"0c861162","214":"0c861162","478":"41553a2c","657":"b3679838","677":"e5f38281","762":"a285c079"}[chunkId] + ".chunk.css";
};